import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-213ac21d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "shop"
}
const _hoisted_2 = { class: "row row-eq-height" }
const _hoisted_3 = { class: "col-12 col-lg-6" }
const _hoisted_4 = {
  class: "bg-white position-relative mb-3",
  style: {"padding-bottom":"100%","height":"0"}
}
const _hoisted_5 = {
  class: "position-absolute w-100 h-100",
  style: {"left":"0","top":"0"}
}
const _hoisted_6 = { class: "col-12 col-lg-6 pl-0 d-flex flex-column" }
const _hoisted_7 = { class: "equals-height" }
const _hoisted_8 = { class: "bg-darkgray px-3" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = {
  style: {"-webkit-line-clamp":"2"},
  class: "text-claim brand-name font-weight-bold text-darkgray-iwari mt-md-3 text-uppercase"
}
const _hoisted_12 = {
  style: {"-webkit-line-clamp":"3"},
  class: "text-claim product-name font-weight-bold text-gray-iwari"
}
const _hoisted_13 = { class: "d-flex" }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<span class=\"d-flex align-items-center\" data-v-213ac21d><i class=\"material-icons small\" data-v-213ac21d>star</i><i class=\"material-icons small\" data-v-213ac21d>star</i><i class=\"material-icons small\" data-v-213ac21d>star</i><i class=\"material-icons small\" data-v-213ac21d>star</i><i class=\"material-icons small mr-1\" data-v-213ac21d>star</i> 0 </span><span class=\"mx-2\" data-v-213ac21d>|</span>", 2)
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons small mr-1" }, "comment", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "|", -1))
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons mr-1 small" }, "local_grocery_store", -1))
const _hoisted_21 = { class: "my-2 pb-2 price-block" }
const _hoisted_22 = { class: "my-0 product-price font-weight-bold" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-small deep-orange-text" }, "S/", -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode()
const _hoisted_25 = {
  class: "deep-orange-text",
  id: "spanPrice"
}
const _hoisted_26 = {
  key: 0,
  id: "spanPriceOffer",
  class: "font-small text-strike ml-2"
}
const _hoisted_27 = {
  key: 1,
  class: "btn btn-deep-orange btn-rounded shadow-none ml-3 px-2 py-2 d-inline"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "local_offer", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  name: "price",
  id: "price",
  type: "hidden",
  value: "0"
}, null, -1))
const _hoisted_30 = {
  key: 0,
  class: "d-flex align-items-center mb-1"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-semibold text-muted mb-0 mr-2" }, "Colecciones:", -1))
const _hoisted_32 = ["title"]
const _hoisted_33 = ["title"]
const _hoisted_34 = {
  key: 1,
  class: "c-input-presentation d-flex align-items-center"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-semibold text-muted mb-0 mr-2 invisible" }, "Colecciones:", -1))
const _hoisted_36 = { class: "mb-2" }
const _hoisted_37 = ["onClick", "onMouseenter"]
const _hoisted_38 = ["src"]
const _hoisted_39 = {
  key: 2,
  class: "d-flex align-items-center mb-2 c-input-presentation"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-semibold d-block text-muted mb-0 mr-2" }, "Tallas:", -1))
const _hoisted_41 = { class: "measures px-3" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-center font-weight-bold my-4" }, "Guía de medidas", -1))
const _hoisted_43 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_44 = ["id", "href", "aria-controls", "onClick"]
const _hoisted_45 = { class: "tab-content pt-3" }
const _hoisted_46 = ["id", "aria-labelledby"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row text-center font-weight-bold" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col border-right p-1" }, "PE"),
  /*#__PURE__*/_createElementVNode("div", { class: "col border-right p-1" }, "US"),
  /*#__PURE__*/_createElementVNode("div", { class: "col p-1" }, "CM.")
], -1))
const _hoisted_48 = { class: "col border-right p-1" }
const _hoisted_49 = { class: "col border-right p-1" }
const _hoisted_50 = { class: "col p-1" }
const _hoisted_51 = { class: "text-center mt-4" }
const _hoisted_52 = {
  key: 3,
  class: "d-flex align-items-center mb-1"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-semibold text-muted mb-0 mr-2" }, "Colores:", -1))
const _hoisted_54 = {
  key: 0,
  class: "d-inline-block font-weight-normal px-3 py-1 border rounded-sm bg-white"
}
const _hoisted_55 = {
  key: 1,
  class: "d-inline-block font-weight-normal px-3 py-1 border rounded-sm bg-white"
}
const _hoisted_56 = {
  key: 4,
  class: "d-flex align-items-center mb-2 c-input-presentation"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-semibold text-muted mb-0 mr-2 invisible" }, "Colores:", -1))
const _hoisted_58 = {
  key: 0,
  class: "d-flex mr-1"
}
const _hoisted_59 = ["onMouseenter"]
const _hoisted_60 = ["title", "onClick"]
const _hoisted_61 = { class: "d-flex align-items-center mb-2 c-input-presentation" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-semibold text-muted mb-0" }, "Cantidad:", -1))
const _hoisted_63 = { class: "ml-2" }
const _hoisted_64 = { class: "d-flex bg-white rounded-sm border py-1 px-1" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "arrow_drop_down", -1))
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = { class: "px-3 d-inline-block font-weight-normal input-quantity text-center" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "arrow_drop_up", -1))
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = /*#__PURE__*/_createStaticVNode("<div class=\"mt-0 d-flex delivery c-input-presentation\" data-v-213ac21d><div class=\"rounded-sm p-3 bg-white w-auto mr-3 flex-1 d-flex align-items-center\" data-v-213ac21d><div data-v-213ac21d><span class=\"text-primary d-flex align-items-center small font-weight-bold\" data-v-213ac21d><i class=\"material-icons mr-1\" data-v-213ac21d>two_wheeler</i> Delivery desde S/ 9.90</span><span class=\"d-block\" data-v-213ac21d>Recíbelo en casa entre 15 y 25 días.</span><span data-v-213ac21d><a class=\"small font-weight-semibold\" href=\"#\" data-v-213ac21d>Calcular con tu dirección</a></span></div></div><div class=\"d-flex flex-column\" data-v-213ac21d><button class=\"btn btn-md btn-deep-orange shadow-sm mb-2 w-100 flex-1 text-white\" data-v-213ac21d>COMPRAR AHORA</button><button class=\"btn btn-md btn-warning shadow-sm flex-1\" data-v-213ac21d>AGREGAR AL CARRITO</button></div></div>", 1)
const _hoisted_71 = { class: "mt-2" }
const _hoisted_72 = { class: "font-weight-bold d-flex align-items-center" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons mr-1" }, "store", -1))
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" Tienda: ")
const _hoisted_75 = { class: "text-primary ml-2 d-inline-block" }
const _hoisted_76 = { class: "mt-3 related-other-store" }
const _hoisted_77 = {
  key: 0,
  class: "c-other-store"
}
const _hoisted_78 = /*#__PURE__*/_createStaticVNode("<p data-v-213ac21d><i class=\"material-icons mr-1\" style=\"margin-left:2px;\" data-v-213ac21d>add_business</i> En otras tiendas: </p><ul class=\"m-0\" data-v-213ac21d><li class=\"c-other-store__item\" data-v-213ac21d><p class=\"price\" data-v-213ac21d><span data-v-213ac21d>S/</span> 36.90</p><i class=\"material-icons ml-auto pointer text-primary\" data-v-213ac21d>launch</i><p data-v-213ac21d>Tienda: Globo Azul SAC</p></li><li class=\"c-other-store__item\" data-v-213ac21d><p class=\"price\" data-v-213ac21d><span data-v-213ac21d>S/</span> 36.90</p><i class=\"material-icons ml-auto pointer text-primary\" data-v-213ac21d>launch</i><p data-v-213ac21d>Tienda: Globo Azul SAC</p></li><li class=\"c-other-store__item\" data-v-213ac21d><p class=\"price\" data-v-213ac21d><span data-v-213ac21d>S/</span> 36.90</p><i class=\"material-icons ml-auto pointer text-primary\" data-v-213ac21d>launch</i><p data-v-213ac21d>Tienda: Globo Azul SAC</p></li></ul>", 2)
const _hoisted_80 = [
  _hoisted_78
]
const _hoisted_81 = { class: "col-12" }
const _hoisted_82 = { class: "card mt-5" }
const _hoisted_83 = { class: "card-body" }
const _hoisted_84 = { class: "font-weight-semibold mb-3" }
const _hoisted_85 = { class: "row" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, null, -1))
const _hoisted_87 = { class: "card mt-5" }
const _hoisted_88 = { class: "card-body" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "font-weight-semibold mb-3" }, "Compra frecuente", -1))
const _hoisted_90 = { class: "row" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, null, -1))
const _hoisted_92 = {
  key: 0,
  class: "col-12 mt-5"
}
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "font-weight-semibold" }, "Productos relacionados", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inner_image_zoom = _resolveComponent("inner-image-zoom")!
  const _component_PhotoOptionCarousel = _resolveComponent("PhotoOptionCarousel")!
  const _component_custom_dropdown = _resolveComponent("custom-dropdown")!
  const _component_mdb_modal_body = _resolveComponent("mdb-modal-body")!
  const _component_mdb_modal = _resolveComponent("mdb-modal")!
  const _component_the_garment_popup = _resolveComponent("the-garment-popup")!
  const _component_TheProductTabs = _resolveComponent("TheProductTabs")!
  const _component_ProductCardSelectable = _resolveComponent("ProductCardSelectable")!
  const _component_ProductCarousel = _resolveComponent("ProductCarousel")!

  return (_ctx.product != null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_inner_image_zoom, {
                  src: _ctx.currentPhoto,
                  zoomType: "hover",
                  hideHint: true
                }, null, 8, ["src"])
              ])
            ]),
            (_ctx.slides.length > 0)
              ? (_openBlock(), _createBlock(_component_PhotoOptionCarousel, {
                  key: 0,
                  slides: this.slides,
                  onChangePreview: _ctx.updatePreview
                }, null, 8, ["slides", "onChangePreview"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("h4", _hoisted_11, _toDisplayString(_ctx.product.attributes.brand), 1),
                    _createElementVNode("h4", _hoisted_12, _toDisplayString(_ctx.product.name), 1),
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("span", _hoisted_16, [
                        _hoisted_17,
                        _createTextVNode(" " + _toDisplayString(_ctx.product.comments.length) + " comentarios", 1)
                      ]),
                      _hoisted_18,
                      _createElementVNode("span", _hoisted_19, [
                        _hoisted_20,
                        _createTextVNode(" " + _toDisplayString((_ctx.product.sold === 1)? _ctx.product.sold + ' vendido' : _ctx.product.sold + ' vendidos'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("h2", _hoisted_22, [
                        _hoisted_23,
                        _hoisted_24,
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.price.toFixed(2)), 1),
                        (_ctx.strike)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, "S/ " + _toDisplayString(_ctx.strike), 1))
                          : _createCommentVNode("", true),
                        (_ctx.product.offer)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                              _hoisted_28,
                              _createTextVNode(" -" + _toDisplayString(_ctx.product.offer.percent) + "%", 1)
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_29
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  (_ctx.product.collection && _ctx.product.collection.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _hoisted_31,
                        (!_ctx.hoverCollection)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "name-in-collection d-inline-block font-weight-normal px-3 py-1 border rounded-sm bg-white",
                              title: _ctx.product.name
                            }, _toDisplayString(_ctx.product.name), 9, _hoisted_32))
                          : _createCommentVNode("", true),
                        (_ctx.hoverCollection)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              style: {"-webkit-line-clamp":"1"},
                              class: "text-claim name-in-collection font-weight-normal px-3 py-1 border rounded-sm bg-white",
                              title: _ctx.nameCollection
                            }, _toDisplayString(_ctx.nameCollection), 9, _hoisted_33))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.product.collection && _ctx.product.collection.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _hoisted_35,
                        _createElementVNode("ul", _hoisted_36, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.collection, (item) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: item.id,
                              class: "ml-0 mr-1"
                            }, [
                              _createElementVNode("span", {
                                onClick: ($event: any) => (_ctx.goToCollection(item.slug)),
                                onMouseenter: ($event: any) => {_ctx.nameCollection = item.name; _ctx.hoverCollection = true;},
                                onMouseout: _cache[0] || (_cache[0] = ($event: any) => {_ctx.hoverCollection = false;})
                              }, [
                                _createElementVNode("img", {
                                  src: _ctx.siteUrl + item.thumb,
                                  alt: "",
                                  class: _normalizeClass((item.slug === _ctx.product.slug)? 'active' : '')
                                }, null, 10, _hoisted_38)
                              ], 40, _hoisted_37)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.product.attributes.dimensions !== 'custom' && _ctx.sizeSelectable )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _hoisted_40,
                        _createElementVNode("div", null, [
                          _createVNode(_component_custom_dropdown, {
                            tabindex: 1,
                            options: _ctx.sizeOptions,
                            onSelectOption: _ctx.selectPresentation,
                            selected: _ctx.sizeSelected
                          }, null, 8, ["options", "onSelectOption", "selected"]),
                          (_ctx.product.measure)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalShoes = true)),
                                class: "btn btn-md btn-link"
                              }, "Guía de medidas "))
                            : _createCommentVNode("", true),
                          (_ctx.product.measure)
                            ? (_openBlock(), _createBlock(_component_mdb_modal, {
                                key: 1,
                                show: _ctx.modalShoes && _ctx.product.measure,
                                onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modalShoes = false))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_mdb_modal_body, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_41, [
                                        _hoisted_42,
                                        _createElementVNode("ul", _hoisted_43, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.measure.detail, (group, index) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                              key: group.id,
                                              class: "nav-item"
                                            }, [
                                              _createElementVNode("a", {
                                                class: _normalizeClass(["nav-link", (index === _ctx.tabMeasureSelected)? 'active' : '']),
                                                id: group.id + '-tab',
                                                href: '#tab_' + group.id,
                                                "aria-controls": 'tab_' + group.id,
                                                onClick: ($event: any) => (_ctx.tabMeasureSelected = index),
                                                "data-toggle": "tab",
                                                role: "tab",
                                                "aria-selected": "true"
                                              }, _toDisplayString(group.name), 11, _hoisted_44)
                                            ]))
                                          }), 128))
                                        ]),
                                        _createElementVNode("div", _hoisted_45, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.measure.detail, (group, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              role: "tabpanel",
                                              class: _normalizeClass(["tab-pane fade container", (index === _ctx.tabMeasureSelected)? 'show active' : '']),
                                              key: group.id,
                                              id: 'tab-' + group.id,
                                              "aria-labelledby": group.id + '-tab'
                                            }, [
                                              _hoisted_47,
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.list, (item) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  class: "row text-center row-measure border-top",
                                                  key: item.id
                                                }, [
                                                  _createElementVNode("div", _hoisted_48, _toDisplayString(item.pe), 1),
                                                  _createElementVNode("div", _hoisted_49, _toDisplayString(item.us), 1),
                                                  _createElementVNode("div", _hoisted_50, _toDisplayString(item.cm), 1)
                                                ]))
                                              }), 128))
                                            ], 10, _hoisted_46))
                                          }), 128))
                                        ])
                                      ]),
                                      _createElementVNode("p", _hoisted_51, [
                                        _createElementVNode("button", {
                                          class: "btn btn-primary",
                                          type: "button",
                                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modalShoes = false))
                                        }, "CERRAR")
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["show"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_the_garment_popup, { product: _ctx.product }, null, 8, ["product"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.currentColor.name && _ctx.currentColor.name !== 'Color único' && _ctx.product.colors.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _hoisted_53,
                        _createElementVNode("div", null, [
                          (!_ctx.hoverColor)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(_ctx.currentColor.name), 1))
                            : _createCommentVNode("", true),
                          (_ctx.hoverColor)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(_ctx.nameColor), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.currentColor.name && _ctx.currentColor.name !== 'Color único' && _ctx.product.colors.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                        _hoisted_57,
                        (_ctx.product.colors.length > 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.colors, (color) => {
                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                  (color.photos && color.photos[0] && color.photos[0].path && color.generalStock > 0)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: color.id,
                                        class: "item-color mr-2 pointer",
                                        onMouseenter: ($event: any) => {_ctx.hoverColor = true; _ctx.nameColor = color.name },
                                        onMouseout: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hoverColor = false))
                                      }, [
                                        _createElementVNode("i", {
                                          title: color.name,
                                          class: _normalizeClass(["w-100 d-block h-100 rounded-sm bg-white border", _ctx.getClassesColor(color)]),
                                          style: _normalizeStyle('background-image: url(\''+ _ctx.siteUrl + color.photos[0].path + '\')'),
                                          onClick: ($event: any) => (_ctx.selectColor(color))
                                        }, null, 14, _hoisted_60)
                                      ], 40, _hoisted_59))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 256))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_61, [
                    _hoisted_62,
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("button", {
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.lessQuantity())),
                          class: "btn shadow-none border-0 p-0"
                        }, _hoisted_66),
                        _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.quantity), 1),
                        _createElementVNode("button", {
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.moreQuantity())),
                          class: "btn shadow-none border-0 p-0"
                        }, _hoisted_69)
                      ])
                    ])
                  ])
                ]),
                _hoisted_70,
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("div", _hoisted_72, [
                    _hoisted_73,
                    _hoisted_74,
                    _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.product.nameCommerce), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_76, [
              (_ctx.showRelated)
                ? (_openBlock(), _createElementBlock("div", _hoisted_77, _hoisted_80))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_81, [
            _createVNode(_component_TheProductTabs, { product: _ctx.product }, null, 8, ["product"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.combos, (combo, key) => {
            return (_openBlock(), _createElementBlock("div", {
              key: key,
              class: "col-12"
            }, [
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("h5", _hoisted_84, _toDisplayString(combo.title), 1),
                  _createElementVNode("div", _hoisted_85, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(combo.products, (productInCombo, keyProduct) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "col-3",
                        key: keyProduct
                      }, [
                        _createVNode(_component_ProductCardSelectable, { product: productInCombo }, null, 8, ["product"])
                      ]))
                    }), 128)),
                    _hoisted_86
                  ])
                ])
              ])
            ]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.frequents, (frequent, key) => {
            return (_openBlock(), _createElementBlock("div", {
              key: key,
              class: "col-12"
            }, [
              _createElementVNode("div", _hoisted_87, [
                _createElementVNode("div", _hoisted_88, [
                  _hoisted_89,
                  _createElementVNode("div", _hoisted_90, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(frequent.products, (productInFrequent, keyProduct) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "col-3",
                        key: keyProduct
                      }, [
                        _createVNode(_component_ProductCardSelectable, {
                          product: productInFrequent,
                          frequents: true
                        }, null, 8, ["product"])
                      ]))
                    }), 128)),
                    _hoisted_91
                  ])
                ])
              ])
            ]))
          }), 128)),
          (_ctx.related.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                _hoisted_93,
                _createVNode(_component_ProductCarousel, {
                  name: "",
                  products: _ctx.related
                }, null, 8, ["products"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}